module.exports = __webpack_public_path__ + "static/img/icon_end.036a353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/icon_end.png
// module id = 643
// module chunks = 2